export default __webpack_public_path__ + "media/images/affaire-bleu-f9041a9efe45e105d7ff1ce7a25532e7.png";